const PaymentFancyDivider = () => {
  return (
    <div className="flex items-center py-5 pb-0">
      <hr className="border-t border-dashed border-light-900 flex-grow" />
    </div>
  );
};

export { PaymentFancyDivider };
